import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CloudinaryModule, lazyload, placeholder } from "@cloudinary/ng";
import { Cloudinary, CloudinaryImage } from "@cloudinary/url-gen";
import { trim } from "@cloudinary/url-gen/actions/reshape";
import { fill, fit } from "@cloudinary/url-gen/actions/resize";
import { EntityWithTemplate, Image, Job, JobBoardPageComponent } from "@interfaces";
import { AppShellNoRenderDirective } from "src/app/directives/app-shell-no-render.directive";
import { jobCategories } from "src/app/helpers/job-constants";
import { StripTagsPipe } from "src/app/pipes/strip-tags.pipe";
import { SubdomainService } from "src/app/rest/subdomain.service";
import { convertJobAddress } from "src/app/routes/jobs/job-helpers";

@Component({
    selector: "app-job-card",
    standalone: true,
    imports: [CommonModule, RouterModule, CloudinaryModule, AppShellNoRenderDirective, AppShellNoRenderDirective, StripTagsPipe],
    templateUrl: "./job-card.component.html",
})
export class JobCardComponent implements OnInit {
    @Input() job: Job;
    @Input() entity: EntityWithTemplate;
    @Input() component: JobBoardPageComponent;
    public imageUrl: string;
    public backgroundStyle = {};
    public logoImg!: CloudinaryImage;
    public thumbnail!: CloudinaryImage;
    public locationString = "";
    public plugins = [lazyload(), placeholder({ mode: 'predominant-color' })];
    public client;

    constructor(private subdomain: SubdomainService) {}

    ngOnInit() {
        const formattedAddress = convertJobAddress(this.job.locationMeta);
        this.locationString =
            this.job.locationLabel ||
            formattedAddress?.addressLocality ||
            formattedAddress?.addressRegion ||
            this.job.location;

        this.subdomain.getClient().subscribe((client) => {
            this.client = client;
            this.setupLogo(this.job.image || client?.logo);
        });

        if (this.job?.thumbnail?.public_id) {
            this.setupThumbnail(this.job.thumbnail);
        } else if (this.job?.videoData?.customThumbnail?.public_id) {
            this.setupThumbnail(this.job.videoData.customThumbnail);
        } else if (this.job?.videoData?.thumbnail) {
            this.imageUrl = this.job.videoData.thumbnail;
        }
    }

    private setupThumbnail(thumbnail: Image) {
        const cld = new Cloudinary({ cloud: { cloudName: "minirobot" } });
        this.thumbnail = cld.image(thumbnail.public_id);
        this.thumbnail.resize(fill().width(250).height(187));
    }

    private setupLogo(image: Image) {
        if(image.public_id) {
            const cld = new Cloudinary({ cloud: { cloudName: "minirobot" } });
            this.logoImg = cld.image(image.public_id);
            this.logoImg.resize(fit().width(75).height(75)).reshape(trim());
        }
    }

    public mapCategoryToLabel(cat: string) {
        const match = jobCategories.find((category: any) => {
            return category.value === cat;
        });
        return match.label;
    }
}
